React = require 'react'
t = require('views/internal/recup-with-helpers')()
helpers = require './helpers'

{ createBackgroundStyle } = helpers

module.exports = class ColorChooserComponent extends React.Component
  displayName: 'ColorChooserComponent'

  constructor: (props) ->
    # XXX: duplicated state
    @state =
      background: null
    super props

  componentDidMount: ->
    setTimeout (=> @chooserElem?.focus()), 10

  render: t.renderable ->
    { background } = @state
    { colors, selectedBackground } = @props

    onBackgroundClick = (bg) =>
      # XXX: duplicated state
      @setState { background: bg }
      @props.onSelect bg

    setChooserElem = (elem) => @chooserElem = elem

    t.div '.background-chooser', { ref: setChooserElem, tabIndex: 0 }, ->
      t.ul '.background-grid.more-colors', ->
        colors.forEach (bg) ->
          isSelected = bg.value ==
            if background?
              background.value
            else
              selectedBackground.value

          t.li '.background-grid-item', ->
            t.button '.background-grid-trigger', {
              className: t.classify { selected: isSelected }
              key: bg.value
              onClick: -> onBackgroundClick bg
              role: 'button'
              style: createBackgroundStyle bg
              title: bg.value
            }, ->
              if isSelected
                t.icon 'check'



// WEBPACK FOOTER //
// ./app/scripts/views/board-create/color-chooser-component.coffee